export default "__VITE_ASSET__2k$Ldc0T__"